import React from "react";

import styles from "../styles/catalog.module.scss";

import { Button } from "../shared/components/Button";
import { Title } from "../shared/components/Title";

import { Drawer, Input } from "@components";
import ROLES from "data/Roles";
import dayjs from "dayjs";
import { isMobile } from "react-device-detect";
import { EllipsisVerticalIcon } from "shared/components/Icons";
import { Icon } from "shared/components/core/Icon";
import GeneralDiscount from "shared/containers/Catalog/Product/GeneralDiscount";
import { CatalogAPI } from "../providers/CatalogAPI";
import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { Loading } from "../shared/components/Loading";
import { Tabs } from "../shared/components/Tabs";
import { AddCategory } from "../shared/containers/Catalog/Category/AddCategory";
import EditCategory from "../shared/containers/Catalog/Category/EditCategory";
import SortCategories from "../shared/containers/Catalog/Category/SortCategories";
import { CategoryItem } from "../shared/containers/Catalog/CategoryItem";
import { ManagePlaces } from "../shared/containers/Catalog/Places/ManagePlaces";
import AddProduct from "../shared/containers/Catalog/Product/AddProduct";
import EditProduct from "../shared/containers/Catalog/Product/EditProduct";
import SortProducts from "../shared/containers/Catalog/Product/SortProducts";
import { ManageTags } from "../shared/containers/Catalog/Tags/ManageTags";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";
import { BrandCloneCatalog } from "./Catalog/BrandCloneCatalog";
import { ReplicateCatalog } from "./Catalog/ReplicateCatalog";
import { SKUDrawer } from "./Catalog/SKUDrawer";
import { ShutdownDrawer } from "./Catalog/ShutdownDrawer";
import GroupCategories from "shared/containers/Catalog/Category/GroupCategories";
import { Environment } from "shared/core/Environment";
import StepsDatabase from "shared/containers/Catalog/StepsDatabase";
import IfoodLogo from "../assets/ifood-logo.png";
import ImportIFood from "shared/containers/Catalog/ImportIFood";
import { Link } from "react-router-dom";

const CatalogTabs = {
  DELIVERY: {
    key: "DELIVERY",
    name: "Delivery",
  },
  INDOOR: {
    key: "INDOOR",
    name: "Indoor",
  },
};
export default class Catalog extends React.Component {
  state = {
    catalogService: CatalogTabs.DELIVERY.key,
    catalog: { items: [] },
    openAddCategory: false,
    openEditCategory: false,
    openAddProduct: false,
    openEditProduct: false,
    openProductOrdination: false,
    openCategoryOrdination: false,
    openGroupCategories: false,
    openCloneCatalog: false,
    openReplicateCatalog: false,
    openShutdownDrawer: false,
    openManageTags: false,
    openManagePlaces: false,
    selectedItem: null,
    environment: {},
    catalog_imported: {},
    loading: false,
    canUpdate: true,
    open_export_sku: false,
    searchTerm: "",
    openOptions: false,
    openGeneralDiscount: false,
    openStepsDatabase: false,
    openImportIFood: false,
    openChangeMultipleProducts: false,
    holdingId: null,
  };

  constructor(props) {
    super(props);
  }

  executeOnSchema(item, callback) {
    for (let field of [
      "items",
      "extra_ingredients",
      "edges",
      "doughs",
      "sizes",
    ]) {
      if (item[field] && item[field].length > 0) {
        for (let children of item[field]) {
          this.executeOnSchema(children, callback);
          callback(children, item, field);
        }
      }
    }
  }

  searchItemOnCatalog(e) {
    const { catalog } = this.state;
    const searchTerm = (e.target.value || "").toLowerCase();
    this.setState({ searchTerm: searchTerm, nextPage: 0 });
    let ocurrences = 0;

    this.executeOnSchema(catalog, (item) => {
      item.visible = !searchTerm;
      if (searchTerm) {
        item.visible =
          item.visible ||
          (item.name || "").toLowerCase().indexOf(searchTerm) > -1;
        item.visible =
          item.visible ||
          (item.sku || "").toLowerCase().indexOf(searchTerm) > -1;
      }

      if (item.visible) {
        ocurrences++;
      } else {
        for (let field of [
          "items",
          "extra_ingredients",
          "edges",
          "doughs",
          "sizes",
        ]) {
          if (item[field] && item[field].length > 0) {
            for (let children of item[field]) {
              if (children.visible) {
                item.visible = true;
                break;
              }
            }
            if (item.visible) {
              break;
            }
          }
          if (item.visible) {
            break;
          }
        }
      }
    });

    this.setState({ catalog, ocurrences: !searchTerm ? null : ocurrences });
  }

  async componentDidMount() {
    this.setState({
      loading: true,
    });

    const environment = EnvironmentStorage.getEnvironment();
    const catalog = (
      await CatalogAPI.getCatalogByService(null, "DELIVERY")
    ).getData({
      items: [],
      type: "catalog",
      service: "DELIVERY",
    });
    this.executeOnSchema(catalog, (i) => (i.visible = true));

    const extras = {};
    if (environment.type == "BRAND") {
      const environmentId = EnvironmentStorage.getSelectedEnvironment();
      extras.catalog_imported = await EnvironmentsAPI.getConfigurationsByAlias(
        environmentId,
        "catalog_imported"
      );
    } else {
      extras.catalog_imported = null;
    }

    let userRole = UserStorage.getLoggedUser()?.role;

    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();

    this.setState({
      environment: environment,
      catalog: catalog,
      ocurrences: null,
      loading: false,
      canUpdate: userRole !== ROLES.SHOPKEEPER,
      holdingId,
      ...extras,
    });
  }

  async reloadCatalog() {
    const { catalogService } = this.state;

    this.setState({
      loading: true,
    });
    await this.loadCatalog(catalogService);
    this.setState({
      loading: false,
    });
  }

  async loadCatalog(catalogService) {
    const catalog = (
      await CatalogAPI.getCatalogByService(null, catalogService)
    ).getData({
      items: [],
      service: catalogService,
      type: "catalog",
    });
    this.executeOnSchema(catalog, (i) => (i.visible = true));
    this.setState({ catalog });
  }

  async applyRulesToCatalog(rules) {
    const services = Object.values(CatalogTabs);

    for (const service of services) {
      const response = await CatalogAPI.shutdownCatalog({
        service: service.key,
      });
      if (response.getErrors([]).length > 0) {
        alert({
          text: `Não foi possível aplicar a ruptura no cardápio "${
            service.name
          }" - ${response.getErrors([])[0]}`,
        });
      }
    }

    // Recarrega o cardapio atual
    await this.reloadCatalog();
  }

  async onSaveCatalog(catalog, reload = true, service = null) {
    await CatalogAPI.putCatalog(catalog, service || this.state.catalogService);
    if (reload) {
      await this.reloadCatalog();
    }
  }

  async onChangeCatalogTab(catalogTab) {
    this.setState({
      loading: true,
      catalogService: CatalogTabs[catalogTab].key,
    });

    await this.loadCatalog(CatalogTabs[catalogTab].key);

    this.setState({
      loading: false,
    });
  }

  render() {
    const {
      catalogService,
      catalog,
      openAddCategory,
      openEditCategory,
      openAddProduct,
      openEditProduct,
      openProductOrdination,
      openCategoryOrdination,
      openGroupCategories,
      openManageTags,
      openManagePlaces,
      selectedItem,
      selectedCategory,
      environment,
      openCloneCatalog,
      openReplicateCatalog,
      catalog_imported,
      openShutdownDrawer,
      canUpdate,
      loading,
      open_export_sku,
      searchTerm,
      openOptions,
      openGeneralDiscount,
      openImportIFood,
      openChangeMultipleProducts,
      openStepsDatabase,
      holdingId,
    } = this.state;

    const getSubtitle = () => {
      if (environment?.brand) {
        return (
          `${environment.brand.name} - ${environment.name}` +
          (environment.active === false ? " (Inativa)" : "")
        );
      }
      return (
        <>
          <p>{environment?.name}</p>
          {catalog_imported && catalog_imported.name && (
            <p className="mt-5 p-5" style={{ fontSize: 12 }}>
              Importado da unidade {catalog_imported.name} em{" "}
              {dayjs(catalog_imported.date).format("DD/MM/YYYY HH:mm")}
            </p>
          )}
        </>
      );
    };

    let userRole = UserStorage.getLoggedUser()?.role;
    if (!userRole) userRole = ROLES.SHOPKEEPER;

    const isCocoBambu = holdingId === 1452;

    return (
      <div className={styles.catalogContainer}>
        <Title
          title="Cardápio"
          subtitle={getSubtitle()}
          backTo={{ url: "/configuracoes", name: "Configurações" }}
        >
          <Input
            search
            placeholder="Buscar por..."
            className="mb-0 pt-0 mr-15"
            design="search"
            value={searchTerm}
            onChange={(e) => {
              this.setState({ searchTerm: e });
              this.searchItemOnCatalog(e);
            }}
          />
          <Button onClick={() => this.setState({ openOptions: true })}>
            <EllipsisVerticalIcon />
          </Button>
          {canUpdate && (
            <Button
              design="primary"
              onClick={() => this.setState({ openAddCategory: true })}
              className={isMobile ? "mr-15" : "ml-10"}
              disabled={canUpdate === false}
              add
            >
              Adicionar categoria
            </Button>
          )}
        </Title>

        <Tabs
          tabs={Object.values(CatalogTabs)}
          activeTab={catalogService}
          onTabSelected={(newCatalogTab) => {
            this.onChangeCatalogTab(newCatalogTab);
          }}
        />

        {loading ? (
          <div className={styles.loading}>
            <Loading />
          </div>
        ) : null}

        {!loading ? (
          <>
            <div className={styles.categories}>
              {catalog.items.map((category, _i) => {
                return (
                  category.visible && (
                    <CategoryItem
                      key={_i}
                      category={category}
                      readOnly={canUpdate === false}
                      onAddProduct={(category) =>
                        canUpdate &&
                        this.setState({
                          openAddProduct: true,
                          selectedItem: category,
                        })
                      }
                      onEditProduct={(product) =>
                        canUpdate &&
                        this.setState({
                          openEditProduct: true,
                          selectedItem: product,
                          selectedCategory: category,
                        })
                      }
                      onEditCategory={(category) =>
                        canUpdate &&
                        this.setState({
                          openEditCategory: true,
                          selectedItem: category,
                        })
                      }
                      onProductOrdination={(category) =>
                        canUpdate &&
                        this.setState({
                          openProductOrdination: true,
                          selectedItem: category,
                        })
                      }
                    />
                  )
                );
              })}
            </div>
          </>
        ) : null}

        <Drawer
          visible={openOptions}
          onClose={() => this.setState({ openOptions: false })}
          title="Ver mais"
        >
          <div className={styles.options}>
            {userRole !== ROLES.SHOPKEEPER && (
              <div
                className={styles.option}
                onClick={() => this.setState({ openCategoryOrdination: true })}
              >
                <div className={styles.icon}>
                  <Icon name="sort-size-up" size="lg" />
                </div>
                <p>Ordenação de categorias</p>
              </div>
            )}

            {userRole !== ROLES.SHOPKEEPER && (
              <div
                className={styles.option}
                onClick={() => this.setState({ openManagePlaces: true })}
              >
                <div className={styles.icon}>
                  <Icon name="store" size="lg" />
                </div>
                <p>Exibição do cardápio</p>
              </div>
            )}

            <div
              className={styles.option}
              onClick={() => this.setState({ openShutdownDrawer: true })}
            >
              <div className={styles.icon}>
                <Icon name="eye-slash" size="lg" light />
              </div>
              <p>Ruptura de produtos</p>
            </div>

            {UserStorage.isGodMode && environment?.type == "BRAND" && (
              <div
                className={styles.option}
                onClick={() => this.setState({ openCloneCatalog: true })}
              >
                <div className={styles.icon}>
                  <Icon name="clone" size="lg" light />
                </div>
                <p>Clonar cardápio</p>
              </div>
            )}

            {userRole !== ROLES.SHOPKEEPER && (
            <div
              className={styles.option}
              onClick={() => this.setState({ openReplicateCatalog: true })}
            >
              <div className={styles.icon}>
                <Icon name="book-open" size="lg" light />
              </div>
              <p>Replicar cardápio</p>
            </div>
            )}

            {UserStorage.isGodMode && (
              <div
                className={styles.option}
                onClick={() => this.setState({ openManageTags: true })}
              >
                <div className={styles.icon}>
                  <Icon name="tags" size="lg" />
                </div>
                <p>Gerenciamento de tags</p>
              </div>
            )}

            {isCocoBambu &&
              [ROLES.ADMIN, ROLES.SUPPORT, ROLES.MANAGER].includes(
                userRole
              ) && (
                <div
                  className={styles.option}
                  onClick={() => this.setState({ openGroupCategories: true })}
                >
                  <div className={styles.icon}>
                    <Icon name="fa-layer-group" size="lg" light />
                  </div>
                  <p>Agrupamento de categorias</p>
                </div>
              )}

            {userRole !== ROLES.SHOPKEEPER && (
              <div
                className={styles.option}
                onClick={() => this.setState({ open_export_sku: true })}
              >
                <div className={styles.icon}>
                  <Icon name="download" size="lg" />
                </div>
                <p>Exportar SKU e Preços</p>
              </div>
            )}

            {userRole !== ROLES.SHOPKEEPER && (
              <div
                className={styles.option}
                onClick={() => this.setState({ openGeneralDiscount: true })}
              >
                <div className={styles.icon}>
                  <Icon name="percentage" size="lg" light />
                </div>
                <p>Desconto geral e aviso</p>
              </div>
            )}

            {userRole !== ROLES.SHOPKEEPER && (
              <div
                className={styles.option}
                onClick={() => this.setState({ openStepsDatabase: true })}
              >
                <div className={styles.icon}>
                  <Icon name="folder-tree" size="lg" />
                </div>
                <p>Banco de etapas</p>
              </div>
            )}

            {UserStorage.isGodMode && (
              <>
                {/* <div
                  className={styles.option}
                  onClick={() => this.setState({ openImportIFood: true })}
                >
                  <div className={styles.icon}>
                    <img src={IfoodLogo} alt="" />
                  </div>
                  <p>Importar cardápio iFood</p>
                </div> */}

                <Link to="precos-e-skus">
                  <div className={styles.option}>
                    <div className={styles.icon}>
                      <Icon name="list" size="lg" />
                    </div>
                    <p>Preços e SKUs</p>
                  </div>
                </Link>
              </>
            )}
          </div>
        </Drawer>

        <GeneralDiscount
          open={openGeneralDiscount}
          setOpen={() => this.setState({ openGeneralDiscount: false })}
        />

        <StepsDatabase
          open={openStepsDatabase}
          setOpen={() => {
            this.setState({ openStepsDatabase: false });
            this.reloadCatalog();
          }}
          catalog={catalog}
        />

        <ImportIFood
          open={openImportIFood}
          setOpen={() => {
            this.setState({ openImportIFood: false });
          }}
        />

        <SortProducts
          open={openProductOrdination}
          setOpen={(status) => this.setState({ openProductOrdination: status })}
          category={selectedItem}
          onSave={async (sortedCategory) => {
            catalog.items = catalog.items.map((category) => {
              if (category.id === selectedItem.id) {
                category.items = sortedCategory.items;
              }
              return category;
            });

            await this.onSaveCatalog(catalog);
            this.setState({ openProductOrdination: false });
          }}
        />

        <ShutdownDrawer
          visible={openShutdownDrawer}
          catalog={catalog}
          onSave={(rules) => this.applyRulesToCatalog(rules)}
          onClose={() => {
            this.setState({ openShutdownDrawer: false });
          }}
        />

        <SKUDrawer
          visible={open_export_sku}
          service={catalogService}
          onSave={() => {
            this.setState({ open_export_sku: false });
            this.reloadCatalog();
          }}
          onClose={() => {
            this.setState({ open_export_sku: false });
          }}
        />

        <BrandCloneCatalog
          visible={openCloneCatalog}
          onSuccesfull={() => {
            this.setState({ openCloneCatalog: false });
            this.componentDidMount();
          }}
          onClose={() => {
            this.setState({ openCloneCatalog: false });
          }}
        />

        <ReplicateCatalog
          visible={openReplicateCatalog}
          catalogService={catalogService}
          onClose={() => {
            this.setState({ openReplicateCatalog: false });
          }}
          onSave={() => {
            this.setState({ openReplicateCatalog: false, openOptions: false });
          }}
        />

        <AddCategory
          open={openAddCategory}
          setOpen={(status) => {
            this.setState({ openAddCategory: status });
          }}
          onSave={async (category) => {
            catalog.items.unshift(category);
            await this.onSaveCatalog(catalog);
            this.setState({
              openAddCategory: false,
            });
          }}
        />

        <ManageTags
          open={openManageTags}
          setOpen={(status) => {
            this.setState({ openManageTags: status });
          }}
          onSave={async (category) => {
            catalog.items.unshift(category);
            await this.onSaveCatalog(catalog);
            this.setState({
              openManageTags: false,
            });
          }}
        />

        <ManagePlaces
          open={openManagePlaces}
          setOpen={(status) => {
            this.setState({ openManagePlaces: status });
          }}
          catalogService={catalogService}
        />

        {this.state.selectedItem && (
          <EditCategory
            service={this.state.catalogService}
            open={openEditCategory}
            catalog={this.state.catalog}
            category={this.state.selectedItem}
            onCategoryUpdated={() => this.reloadCatalog()}
            setOpen={(status) =>
              this.setState({ selectedItem: null, openEditCategory: status })
            }
          />
        )}

        {this.state.selectedItem && catalog && (
          <AddProduct
            open={openAddProduct}
            category={this.state.selectedItem}
            categories={catalog.items}
            catalog={catalog}
            onClose={() => this.setState({ openAddProduct: false })}
            onSave={async (product) => {
              catalog.items = catalog.items.map((category) => {
                if (category.id == selectedItem.id) {
                  category.items.push(product);
                }

                return category;
              });

              await this.onSaveCatalog(catalog);
              this.setState({ openAddProduct: false });
            }}
          />
        )}

        {selectedCategory && (
          <EditProduct
            service={this.state.catalogService}
            open={openEditProduct}
            catalog={catalog}
            category={selectedCategory}
            product={selectedItem}
            onProductUpdated={() => this.reloadCatalog()}
            onClose={() =>
              this.setState({
                openEditProduct: false,
                selectedItem: null,
                selectedCategory: null,
              })
            }
          />
        )}

        {catalog && catalog.items && catalog.items.length ? (
          <SortCategories
            open={openCategoryOrdination}
            catalog={catalog}
            onSave={async (catalog) => {
              await this.onSaveCatalog(catalog);
            }}
            setOpen={(status) =>
              this.setState({ openCategoryOrdination: status })
            }
          />
        ) : null}

        <GroupCategories
          open={openGroupCategories}
          catalog={catalog}
          onSave={async (catalog) => {
            await this.onSaveCatalog(catalog);
          }}
          setOpen={(status) => this.setState({ openGroupCategories: status })}
          service={catalogService}
          onSaveCatalog={async (catalog) => {
            await this.onSaveCatalog(catalog);
          }}
        />
      </div>
    );
  }
}
